import React, { useState, useEffect } from "react";
import "../../../css/WeekLinkSubsc.css";
import WeekTransSubsc from "./WeekTransSubsc";
import Weather from "../../weather/WeatherView";

const WeekLineSubsc = () => {
  const [page, setPage] = useState(1);

  const handlePage = (item: number) => {
    setPage(item + page);
  };

  return (
    <div className="per_week_line_container">
      <WeekTransSubsc handlePage={handlePage} page={page} />
      <Weather page={page} />
    </div>
  );
};

export default WeekLineSubsc;
